const global = 
`
body { margin:0; padding:0; }

`

export default global